import React from 'react';
import PropTypes from 'prop-types';

function Wrapper(props) {
    const { children, isLoading, fullWidth } = props;
    return (
        <div className={`kbe-search-bar-wrapper ${isLoading ? 'kbe-loading-block' : ''}`} data-lvp-webshop-available="true">
            <div className={`kbe-booking-params-wrapper ${fullWidth ? 'is-full-width' : ''}`}>
                { !isLoading && children }
            </div>
        </div>
    );
}

Wrapper.propTypes = {
    children  : PropTypes.node.isRequired,
    isLoading : PropTypes.bool.isRequired,
    fullWidth : PropTypes.bool.isRequired,
};

export default Wrapper;
